import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AccountCircleOffSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AccountCircleOffSVG;
